import { DUMMY_STORE_DETAILS } from "@graphql/fragments/dummy-store-details";
import { gql } from "@stadium/services/apollo-client";

export const fetchDummyStore = gql`
  query dummyStore($number: String!) {
    dummyStore(number: $number) {
      ...DummyStoreDetails
    }
  }
  ${DUMMY_STORE_DETAILS}
`;
